import { render, staticRenderFns } from "./CardDisplay.vue?vue&type=template&id=41b2d5c4"
import script from "./CardDisplay.vue?vue&type=script&lang=js"
export * from "./CardDisplay.vue?vue&type=script&lang=js"
import style0 from "./CardDisplay.vue?vue&type=style&index=0&id=41b2d5c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports